import React, { memo, useState } from 'react';
import { PropTypes } from 'prop-types';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export default memo(SearchBar);

const initState = { search: '' };

function SearchBar(props) {
  const [state, updateState] = useState(initState);
  const history = useHistory();

  const goToSearchPage = () => {
    const search = state.search.trim();
    if (!search) return;

    props.updateMobileMenuState?.({ isOpen: false });

    history.push(`/search?term=${search}`);
    updateState((prevState) => ({ ...prevState, search: '' }));
  };

  const handleEnterPress = ({ keyCode }) => {
    if (keyCode !== 13) return;
    goToSearchPage();
  };

  const handleSearchChange = ({ target: { value: search } }) => {
    updateState((prevState) => ({ ...prevState, search }));
  };

  return (
    <div className="container mr-4">
      <div className="row">
        <div id="custom-search-input" className={`m-0 p-0 ${props.inputClass}`}>
          <div className="input-group input-group-sm flex-nowrap">
            <input
              className="search-query form-control border border-light-gray-3 border-right-0 text-muted font-weight-light nine-tenth-text pl-lg-3"
              placeholder="What do you want to find?"
              onChange={handleSearchChange}
              onKeyUp={handleEnterPress}
              type="text"
              value={state.search}
            />
            <div className="input-group-append">
              <button
                className="btn btn-outline-light-gray-3 search-button border-left-0 py-0 text-reset text-decoration-none"
                onClick={goToSearchPage}
              >
                <FontAwesomeIcon
                  icon={faSearch}
                  className="text-icon-link-gray"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .form-control:focus {
          box-shadow: none;
          border-color: var(--third-gray);
        }

        .search-query {
          border-top-left-radius: 1rem;
          border-bottom-left-radius: 1rem;
        }

        .search-button {
          border-top-right-radius: 1rem !important;
          border-bottom-right-radius: 1rem !important;
        }

        .search-query:focus + button {
          z-index: 3;
        }

        .search-query::placeholder {
          color: var(--icon-link-gray);
        }

        @media (min-width: 992px) {
          .search-query {
            width: 300px;
          }
        }
      `}</style>
    </div>
  );
}

SearchBar.propTypes = {
  inputClass: PropTypes.string,
  updateMobileMenuState: PropTypes.func,
};
